function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as _jsx } from "react/jsx-runtime";
import Colors from "styles/colors";
import SideBySideTabsAndProcessTabs from "segments/desktop/tabs/layouts/side-by-side-tabs-and-process-tabs/side-by-side-tabs-and-process-tabs";
import { StyledSideBySideTabsAndProcessTabsMobileComponent } from "./side-by-side-tabs-and-process-tabs-component.scss";
const SideBySideTabsAndProcessTabsMobileComponent = (_param)=>{
    var { selectedTabBackgroundColor } = _param, rest = _object_without_properties(_param, [
        "selectedTabBackgroundColor"
    ]);
    return /*#__PURE__*/ _jsx(StyledSideBySideTabsAndProcessTabsMobileComponent, {
        className: "side-by-side-tabs-and-process-tabs-mobile-component",
        style: {
            "--selected-tab-background-color": Colors[selectedTabBackgroundColor]
        },
        children: /*#__PURE__*/ _jsx(SideBySideTabsAndProcessTabs, _object_spread({}, rest))
    });
};
export default SideBySideTabsAndProcessTabsMobileComponent;
